/*
 * project-video-carousel.js — First Light Astro
 * Drives the "Project — Video Carousel" section:
 *   - first video active by default (its embed is loaded on render)
 *   - clicking a thumbnail OR the prev/next arrows switches the active video
 *   - switching never autoplays: the new player shows its poster + play button,
 *     and the previously playing embed is unloaded so no audio leaks
 *
 * Theme-editor-safe & leak-free: one IIFE; each root self-inits once
 * (root.dataset.vcReady); a per-root AbortController owns all listeners; the
 * shopify:section lifecycle is bound once globally.
 */
(function () {
  'use strict';

  function activate(root, index) {
    var players = root.querySelectorAll('[data-vc-player]');
    var thumbs = root.querySelectorAll('[data-vc-thumb]');
    var n = players.length;
    if (!n) return;
    index = ((index % n) + n) % n; // wrap-around

    Array.prototype.forEach.call(players, function (player, i) {
      var active = i === index;
      var iframe = player.querySelector('[data-vc-iframe]');
      var video = player.querySelector('video');

      if (active) {
        player.hidden = false;
        // Load the embed if it hasn't been loaded yet (no autoplay param ->
        // the native player shows a poster + play button and waits for click).
        if (iframe && !iframe.getAttribute('src') && iframe.getAttribute('data-src')) {
          iframe.setAttribute('src', iframe.getAttribute('data-src'));
        }
      } else {
        player.hidden = true;
        // Unload the iframe to stop any playback/audio; it reloads to a fresh
        // poster the next time it becomes active.
        if (iframe && iframe.getAttribute('src')) {
          iframe.removeAttribute('src');
        }
        // Pause native Shopify-hosted videos.
        if (video && typeof video.pause === 'function') {
          try { video.pause(); } catch (e) {}
        }
      }
    });

    Array.prototype.forEach.call(thumbs, function (thumb, i) {
      var active = i === index;
      thumb.setAttribute('aria-current', active ? 'true' : 'false');
      thumb.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    root._vcIndex = index;
  }

  function initRoot(root) {
    if (!root || root.dataset.vcReady === '1') return;
    root.dataset.vcReady = '1';

    var controller = new AbortController();
    var signal = controller.signal;
    root._vcController = controller;
    root._vcIndex = 0;

    // Thumbnail clicks
    var thumbs = root.querySelectorAll('[data-vc-thumb]');
    Array.prototype.forEach.call(thumbs, function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = parseInt(thumb.getAttribute('data-vc-index'), 10) || 0;
        activate(root, idx);
      }, { signal: signal });
    });

    // Prev/next arrows (wrap-around)
    var arrows = root.querySelectorAll('[data-vc-arrow]');
    Array.prototype.forEach.call(arrows, function (btn) {
      btn.addEventListener('click', function () {
        var dir = btn.getAttribute('data-vc-arrow') === 'next' ? 1 : -1;
        activate(root, (root._vcIndex || 0) + dir);
      }, { signal: signal });
    });

    root._vcTeardown = function () { controller.abort(); };
  }

  function teardownRoot(root) {
    if (!root) return;
    if (typeof root._vcTeardown === 'function') { root._vcTeardown(); root._vcTeardown = null; }
    root._vcController = null;
    delete root.dataset.vcReady;
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-vc]');
    Array.prototype.forEach.call(roots, initRoot);
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }
  ready(function () { initAll(document); });

  if (!window.__vcBound) {
    window.__vcBound = true;
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target;
      var roots = el && el.querySelectorAll ? el.querySelectorAll('[data-vc]') : [];
      Array.prototype.forEach.call(roots, initRoot);
    });
    document.addEventListener('shopify:section:unload', function (e) {
      var el = e.target;
      if (!el || !el.querySelectorAll) return;
      Array.prototype.forEach.call(el.querySelectorAll('[data-vc]'), teardownRoot);
    });
    // Theme editor: re-activate on block select so the chosen video shows.
    document.addEventListener('shopify:block:select', function (e) {
      var root = e.target && e.target.closest ? e.target.closest('[data-vc]') : null;
      if (!root) return;
      var player = e.target.closest ? e.target.closest('[data-vc-player]') : null;
      if (player) {
        var idx = parseInt(player.getAttribute('data-vc-index'), 10) || 0;
        activate(root, idx);
      }
    });
  }
})();
